import type { IMenuSection } from "@fondationcss/ui";

export const menus: IMenuSection[] = [
  {
    title: 'Enseignement',
    icon: 'chalkboard',
    iconOnly: true,
    maxGroups: 10,
    groups: [
      { title: 'Tableau de bord', icon: 'dashboard', to: '/enseignement/tableau-de-bord', badge: 'beta', },
      { title: 'Présences', icon: 'hand', to: '/enseignement/presences' },
      { title: 'Examens', icon: 'file-circle-check', to: '/enseignement/examens' },
      {
        id: 'enseignement-assignations',
        label: 'Groupe',
        icon: 'chalkboard-user',
        iconOnly: false,
        items: [
          {
            module: 'Parcours.LearningModule',
            items: [
              { title: 'Assiduité', icon: 'users', to: '/enseignement/assiduite', showFooter: false },
            ],
          },
        ],
      },
      {
        id: 'enseignement-individualise',
        label: 'Individualisé',
        icon: 'user',
        iconOnly: false,
        items: [
          {
            module: 'Parcours.LearningModule',
            items: [
              { title: 'Assignations', icon: 'chalkboard-user', to: '/enseignement/assignations', showFooter: false },
              { title: 'Vue consolidée', icon: 'table', to: '/enseignement/vue-consolidee' },
              { title: 'Cumul des heures', icon: 'calculator', to: '/enseignement/cumul-heures' },
            ],
          },
        ],
      },
      { title: 'Rapports', icon: 'file-lines', to: '/enseignement/rapports' }
    ],
  },
  {
    title: 'Planification',
    icon: 'calendar',
    iconOnly: true,
    maxGroups: 10,
    roles: ['Parcours.LearningModule.Superviseur', 'Parcours.ATE.Superviseur'],
    groups: [
      { title: 'Tableau de bord', icon: 'dashboard', to: '/planification/tableau-de-bord', badge: 'beta', },
      {
        id: 'planification-etudiants',
        label: 'Admission',
        icon: 'user-graduate',
        iconOnly: false,
        items: [
          {
            roles: ['Parcours.LearningModule.Superviseur'],
            items: [
              { title: 'Étudiants', icon: 'user-group', to: '/planification/etudiants' },
              { title: 'Fréquentations', icon: 'user-graduate', to: '/planification/frequentations' },
            ],
          },
        ],
      },
      { title: 'Cohortes', icon: 'users', to: '/gestion/cohortes', badge: 'beta' },
      {
        title: 'Groupes',
        roles: ['Parcours.LearningModule.Superviseur'],
        icon: 'chalkboard', to: '/planification/vue-ensemble',
      },
      {
        title: 'Individualisé', icon: 'user', to: '/planification/individualise',
      },
      {
        id: 'enseignement-ate',
        label: 'ATE & Stages',
        icon: 'briefcase',
        iconOnly: false,
        badge: 'beta',
        items: [
          {
            module: 'Parcours.ATE',
            items: [
              { title: 'Stages', icon: 'briefcase', to: '/planification/stages' },
              { title: 'Entreprises', icon: 'building', to: '/planification/entreprises' },
            ],
          },
        ],
      },
      { title: 'Rapports', icon: 'file-lines', to: '/planification/rapports', dimmed: true }
    ],
  },
  {
    title: 'Gestion',
    icon: 'users-gear',
    iconOnly: true,
    roles: ['Parcours.LearningModule.Administrateur', 'Parcours.ATE.Administrateur', 'Parcours.Demonstration.Administrateur'],
    groups: [
      { title: 'Tableau de bord', icon: 'dashboard', to: '/gestion/tableau-de-bord', module: 'Parcours.LearningModule', badge: 'beta', },
      {
        id: 'gestion-supervision',
        label: 'Supervision',
        icon: 'users-gear',
        iconOnly: false,
        items: [
          {
            roles: ['Parcours.LearningModule.Superviseur'],
            items: [
              { title: 'Enseignants', icon: 'chalkboard-user', to: '/gestion/enseignants' },
              { title: 'Embauches', icon: 'chalkboard-user', to: '/gestion/enseignants', badge: 'beta' },
            ],
          },
        ],
      },
      {
        id: 'gestion-administration',
        label: 'Administration',
        icon: 'shield-halved',
        iconOnly: false,
        items: [
          {
            roles: ['Parcours.Locations.Administrateur'],
            items: [
              { title: 'Centres', icon: 'building', to: '/gestion/centres' },
              { title: 'Locaux et ressources', icon: 'door-open', to: '/gestion/locaux-ressources' },
            ],
          },
          {
            roles: ['Parcours.ATE.Administrateur'],
            items: [
              { title: 'Programmes et Compétences', icon: 'box-archive', to: '/gestion/programmes' },
              { title: 'Calendriers', icon: 'calendar', to: '/core/calendar' },
              { title: 'Gabarits', icon: 'layer-group', to: '/gestion/gabarits' },
              { title: 'Références', icon: 'star-half-stroke', to: '/gestion/references' },
            ],
          },
          {
            roles: ['Parcours.Demonstration.Administrateur'],
            items: [
              { title: 'Démonstration', icon: 'flask', to: '/gestion/demonstration' },
            ],
          },
        ],
      },
      { title: 'Rapports', icon: 'file-lines', to: '/gestion/rapports' }
    ],
  },
]